import { type ChannelData } from '@/api/channel'
interface ChannelState {
  channelData: ChannelData
  /**
   * 当前播放视频的唯一标识
   */
  sn4Video: string
}

export default {
  namespaced: true,
  state: () => ({
    channelData: {},
    sn4Video: ''
  }),
  mutations: {
    setChannelData(state: ChannelState, channel: ChannelData) {
      state.channelData = channel
    },
    setSn4Video(state: ChannelState, sn4Video: string) {
      state.sn4Video = sn4Video
    }
  },
  actions: {},
  getters: {}
}
